import { useNavigation } from '@react-navigation/native';
import {
    useMemo,
    useState
} from 'react';
import {
    Platform,
    TouchableWithoutFeedback
} from 'react-native';
import {
    useDispatch,
    useSelector
} from 'react-redux';

import { setFormValue } from '../../actions/forms';
import {
    BigButton,
    Button,
    Icon,
    React,
    Text,
    View
} from '../../common';
import { inAppUpdaterStyles } from '../../common/InAppUpdater';
import { Card } from '../../common/react';
import { hasUnfilledRelatives } from '../../selectors';
import { getFormValues } from '../../selectors/forms';
import { COLORS } from '../../styles/colors';

export const FamilyStoreLocalPanel = () => {
    const formValues = useSelector(getFormValues);
    const hasUnfilled = useSelector(hasUnfilledRelatives);
    const dispatch = useDispatch();
    const [ fullView,
        setFullView ] = useState(false);
    const nav = useNavigation();

    const closeWindowHandler = () => {
        dispatch(setFormValue('hideFamilyWindow', true));
    };

    const goToFamilyHandler = () => {
        nav.navigate('Account', { screen: 'Relatives' });
    };

    const changeFullView = () => setFullView((prev) => !prev);

    const outMessage = useMemo(
        () => (
            <Text
                style={[
                    // styles.textNormal,
                    {
                        color: COLORS.STANDARD_GRAY,
                        lineHeight: 20,
                        fontSize: 14,
                    },
                ]}
                numberOfLines={fullView ? 0 : 2}
            >
                {Object.R('titles.fillRelativeProfilesWindow')}
            </Text>
        ),
        [ fullView ],
    );

    return (
        !formValues?.hideFamilyWindow &&
        hasUnfilled && (
            <Card containerStyle={[ inAppUpdaterStyles.wrapper,
                { position: 'relative' } ]}>
                <View style={inAppUpdaterStyles.lineWrapper}>
                    <TouchableWithoutFeedback onPress={changeFullView}>
                        {Platform.OS === 'web' ? outMessage : <View>{outMessage}</View>}
                    </TouchableWithoutFeedback>
                    <Button
                        action={closeWindowHandler}
                        styles={[
                            inAppUpdaterStyles.closeButton,
                            {
                                position: 'absolute',
                                right: -14,
                                top: -14,
                            },
                        ]}
                    >
                        <Icon
                            name="cross"
                            color="#787878"
                            style={inAppUpdaterStyles.closeIcon}
                        />
                    </Button>
                </View>
                <BigButton
                    styles={inAppUpdaterStyles.button}
                    titleStyles={inAppUpdaterStyles.buttonTitle}
                    title={Object.R('titles.fillRelativeProfilesButton')}
                    action={goToFamilyHandler}
                />
                <View></View>
            </Card>
        )
    );
};
